"use client";

import { useEffect } from 'react';

export function ThemeInitializer() {
  useEffect(() => {
    // Aplicar tema inmediatamente al cargar
    const initializeTheme = () => {
      const savedTheme = localStorage.getItem('abbi_theme') as 'light' | 'dark' | 'system' || 'dark';
      const actualTheme = savedTheme === 'system' ? 
        (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light') : 
        savedTheme;
      
      // Aplicar tema al body y html
      document.body.setAttribute('data-theme', actualTheme);
      document.documentElement.setAttribute('data-theme', actualTheme);
      
      // Aplicar color-scheme también
      document.documentElement.style.colorScheme = actualTheme;
      
      console.log('🎨 [THEME INITIALIZER] Tema aplicado:', actualTheme);
    };
    
    // Ejecutar inmediatamente
    initializeTheme();
    
    // También ejecutar después de un pequeño delay para asegurar
    const timeoutId = setTimeout(initializeTheme, 100);
    
    return () => clearTimeout(timeoutId);
  }, []);

  return null;
}





